<div class="screens-wrapper">
  <div class="gt-filter-container">
    <div class="gt-filter-item">
      <i class="fa fa-refresh gt-refresh"
         [class.spinning]="loading"
         title="Refresh Data"
         role="button"
         tabindex="0"
         (click)="refresh()"
         (keydown.enter)="refresh()"
         (keydown.space)="refresh(); $event.preventDefault()"></i>
    </div>
    <div class="gt-filter-item">
      <div class="btn btn-success btn-xs" (click)="addScreen()">Add New Screen</div>
    </div>
  </div>

  <div adminGrid
       [gridConfig]="gridConfig"
       (gridCallback)="onGridCallback($event)"
       (gridDataLoaded)="onGridDataLoaded($event)"
       (loadingStateChange)="loading = $event"
       class="gizmo-grid"
       tabindex="2"></div>
</div>
